'use strict';

var SignupController = ngtk.controller.Base.extend({

    $inject: ['$scope', '$rootScope', '$timeout', 'growl', 'bbw.RegisterUserSvc', 'bbw.LocationSvc', 'bbw.RedirectSvc'],

    _bbwRegisterUserSvc: undefined,
    _bbwLocationSvc: undefined,
    _bbwRedirectSvc: undefined,
    _locState: undefined,

    _init: function() {
        this.$scope.bbwMessages = bbw.messages;

        this.stepReached = this.step = 1;

        this.user = {};

        bbw.onMobileBack(this.$scope, function() {
            if (this.step > 1) {
                this.prevStep();
            }
        }.bind(this));

        this.$scope.$watch('$ctrl.user.a_sex', function(value, oldValue) {
            if (value === oldValue) {
                return;
            }
            this._updateWantRel(value);
        }.bind(this));

        this._locState = this._bbwLocationSvc.createLocState({
            defaultState: 'step',
            states: {
                step: '{step:[1-4]?}'
            },
            onStateChange: this._onLocStateChange.bind(this)
        });
        this._locState.run();
    },

    _onLocStateChange: function(state) {
        switch (state.name) {
            case "step":
                var step = state.args.step || 1;
                if (step == this.step) {
                    return;
                }
                if (step > this.stepReached) {
                    this._setStepLocState(this.stepReached);
                } else {
                    this.step = step;
                    this.onStepChanged(true);
                }
                break;
        }
    },

    _setStepLocState: function(value) {
        this._locState.setState("step", value > 1 ? {step: value} : {});
    },

    isWantSex: function(value) {
        return angular.isArray(this.user.a_want_sex_) && this.user.a_want_sex_.indexOf(value) >= 0;
    },

    _updateWantRel: function(gender) {
        if (gender === 'm') {
            this.user.a_want_sex_ = ['f'];
            delete this.user.a_want_relations_f_;
        }
    },

    $onInit: function() {
        this.requireEmail = true;
        this.requirePassword = true;
        if (this.oauth) {
            angular.extend(this.user, {
                nickname: this.oauth.nickname || this.oauth.name,
                email: this.oauth.email,
                a_sex: this.oauth.sex,
                city: this.oauth.city,
                a_birthdate: this.oauth.birthdate
            });
            this.requirePassword = false;
            if (this.oauth.email) {
                this.requireEmail = false;
            }
            if (this.oauth.sex) {
                this._updateWantRel(this.oauth.sex);
            }
        }
    },

    submit: function(form) {
        this.$scope.$broadcast('submit-form', {form: form});
        return false;
    },

    prevStep: function() {
        this.$timeout(function() {
            if (this.step > 1 && this.step < 4) {
                this.step--;
                this.stepReached = this.step;
                this.onStepChanged();
            }
        }.bind(this));
    },

    nextStep: function() {
        if (this.nextStepTimeout) {
            return;
        }
        this.nextStepTimeout = this.$timeout(function() {
            if (this.step < 3) {
                this.step++;
                this.stepReached = this.step;
                this.onStepChanged();
            } else {
                this.registerUser();
            }
        }.bind(this), 10).finally(function() {
            this.nextStepTimeout = undefined;
        }.bind(this));
    },

    onStepChanged: function(fromStateChange) {
        if (!fromStateChange) {
            this._setStepLocState(this.step);
        }
        if (this.step > 1 && this.step < 4) {
            this.$rootScope.$broadcast(bbw.globalEvent.mobileBackShow);
        } else {
            this.$rootScope.$broadcast(bbw.globalEvent.mobileBackHide);
        }
    },

    registerUser: function() {
        this.processing = true;
        return this._bbwRegisterUserSvc.registerUser(this._buildUserRegisterDto()).then(function(response) {
            if (response.redirect) {
                this._bbwRedirectSvc.redirect(response.redirect);
            } else {
                this.step = 4;
                this.onStepChanged();
            }
        }.bind(this)).catch(function(error) {
            this._growl.error(error);
        }.bind(this)).finally(function() {
            this.processing = undefined;
        }.bind(this));
    },

    _buildUserRegisterDto: function() {
        var dto = angular.extend(
            {city_id: this.user.city.city_id},
            this._buildUserRegisterDtoPartCopyValues(['a_sex', 'a_birthdate', 'nickname', 'email', 'password']),
            this._buildUserRegisterDtoPartFromArray('a_want_sex_'),
            this._buildUserRegisterDtoPartFromArray('a_want_relations_f_'),
            this._buildUserRegisterDtoPartFromArray('a_want_relations_m_')
        );
        if (this.oauth) {
            dto.oauth = true;
        }
        return dto;
    },

    _buildUserRegisterDtoPartCopyValues: function(keys) {
        return keys.reduce(function(carry, key) {
            if (angular.isDefined(this.user[key])) {
                carry[key] = this.user[key];
            }
            return carry;
        }.bind(this), {});
    },

    _buildUserRegisterDtoPartFromArray: function(key) {
        if (!angular.isArray(this.user[key])) {
            return {};
        }
        return this.user[key]
            .filter(function(value) {
                return !!value;
            }).reduce(function(carry, value) {
                carry[key + value] = true;
                return carry;
            }, {});
    }

});

bbw.guest.SignupComponent = {
    templateUrl: bbw.templateUrl('components/guest/signup.component.html'),
    controller: SignupController,
    bindings: {
        oauth: '<'
    }
};